import gql from 'graphql-tag';

const mutation = gql`
  mutation saveThematicSelection($id: Int, $projectId: Int!, $name: String!, $thematics: [ThematicInput!]!) {
    saveThematicSelection(id: $id, projectId: $projectId, name: $name, thematics: $thematics) {
      selection {
        id
        name
        thematics {
          thematic
          subThematic
          subSubThematic
        }
        createdBy {
          email
          firstName
          lastName
        }
      }
      errors
    }
  }
`;

export default mutation;
